import axios from 'axios';

export interface IDashboard {
  clientId: number;
  clientName: string;
  workspaceId: string;
  reportId: string;
  dashboardName: string;
  displayName: string;
  isActive: boolean;
}

const DashboardService = {
  getAvailableDashboards: (): Promise<IDashboard[]> => {
    return axios.get('/dashboards/available').then((response) => response.data);
  },
  getEmbedParams: (workspaceId: string, reportId: string): Promise<any> => {
    return axios
      .get(`/dashboards/embed?workspaceId=${workspaceId}&reportId=${reportId}`)
      .then((response) => response.data);
  },
};

export default DashboardService;
